// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1584":"b9164732","3613":"b9164732","4766":"b9164732","6700":"b9164732","8212":"b9164732","8840":"b9164732","9424":"b9164732","9723":"b9164732"}[chunkId] + ".chunk.css";
};